import { render, staticRenderFns } from "./ConfigurationManagement.vue?vue&type=template&id=736ca01b"
import script from "./ConfigurationManagement.vue?vue&type=script&lang=js"
export * from "./ConfigurationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports